import React, {PureComponent} from "react"
import styled from "styled-components"

import {H2} from "@irati/ui/src//Typography/Heading"

import RewardAvatar from "./RewardAvatar"

const Header = styled.header`
  display: flex;
  flex-direction: column;
  margin-top: -80px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
    margin-top: 0;
  `}
`

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: column;
    justify-content: flex-start;
  `}
`

interface Props {
  title: string,
  thumbnailImage: string
}

export default class RewardDetail extends PureComponent<Props> {
  render() {
    const {thumbnailImage, title} = this.props

    return (
      <Header>
        <RewardAvatar thumbnailImage={thumbnailImage} />
        <Wrap>
          <H2>{title}</H2>
        </Wrap>
      </Header>
    )
  }
}
